import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {PageTitle} from '../../../_ShakWala/layout/core'
import Expired from '../../pages/package-info/expired/Expired'

const ExpiredPackageMasterPage: React.FC = () => {
  return (
    <Switch>
      <Route path='/package-info/expired/list'>
        <PageTitle>Package Expired List</PageTitle>
        <Expired />
      </Route>
      <Redirect from='/package-info/expired' exact={true} to='/package-info/expired/list' />
      <Redirect to='/package-info/expired/list' />
    </Switch>
  )
}

export default ExpiredPackageMasterPage
